import React from 'react'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import moment from 'moment'
import { IconContext } from 'react-icons'
import { IoIosArrowForward } from 'react-icons/io'
import { GET_STORE } from '@wellbeingxltd/fe-lib/constants'
import { formatPrice, getTransactionStateText } from '@wellbeingxltd/fe-lib/helpers'
import { Button } from 'components'
import './style.scss'

export const TransactionRow = ({ load, toggleTransactionToExport, transaction }) => {
    const { address, ApiIntegration, automationType, date, price, priceDescription, sku, state, title, transactionId, voucherCode, voucherId } =
        transaction
    const history = useHistory()
    const { transactionsToExport } = useSelector(GET_STORE.TRANSACTIONS)
    const { tickets } = useSelector(GET_STORE.TICKETS)

    const renderTicketButton = transaction => {
        const ticket = tickets.find(({ transactionId }) => transactionId === transaction.transactionId)
        const isClosed = ticket?.ticketStatus === 'Ticket Closed'
        const closedBy = isClosed && ticket?.ticketClosedBy ? ticket?.ticketClosedBy : ticket?.ticketType === 'supplier-to-user' ? 'Supplier' : 'User'
        return (
            <div>
                {ticket && (
                    <div className={`supplier-ticket-status ${!isClosed ? 'supplier-ticket-status--open' : ''}`}>
                        {isClosed ? 'Last closed: ' : 'Opened: '}
                        {moment(isClosed ? ticket.ticketCloseDate : ticket.ticketOpenDate).format('Do MMM YYYY')}
                        {closedBy && <p>by {closedBy}</p>}
                    </div>
                )}
                <Button
                    size="small"
                    className="supplierTransactionsPill supplierTransactionsPill--blue supplierTransactionsAction"
                    onClick={() => history.push(`/tickets/${transactionId}`)}
                >
                    Manage tickets
                </Button>
            </div>
        )
    }

    const isProductTransaction = automationType === 'Product'
    const isShopifyTransaction = !!JSON.parse(ApiIntegration)?.shopify
    const hasLinkToTransaction = isProductTransaction && !isShopifyTransaction

    return (
        <tr>
            <td>
                <input
                    type="checkbox"
                    className="supplierTransactionsCheckbox"
                    onChange={() => toggleTransactionToExport(transaction)}
                    checked={transactionsToExport.filter(trans => trans.transactionId === transactionId).length}
                />
            </td>
            <td
                onClick={() => (hasLinkToTransaction ? load(transaction) : null)}
                className={hasLinkToTransaction ? 'supplierTransactionsTitleCell' : 'supplierTransactionsVoucher'}
            >
                <h2 className="supplierTransactionsTitle">{title}</h2>
                {hasLinkToTransaction && (
                    <IconContext.Provider value={{ className: 'supplierTransactionsChevronRight' }}>
                        <IoIosArrowForward />
                    </IconContext.Provider>
                )}
            </td>
            <td>{priceDescription}</td>
            <td>{sku}</td>
            <td className="supplierTransactionsDate">{moment(date).format('DD/MM/YY HH:mm')}</td>
            <td>{transactionId}</td>
            <td>
                {address?.name} {transaction?.receiveDonationEmails && address?.email && `(${address?.email})`}
            </td>
            <td>{voucherCode}</td>
            <td>{renderTicketButton(transaction)}</td>
            <td>
                <span
                    className={`supplierTransactionsPill ${state === 'CONFIRMED' && 'supplierTransactionsPill--dispatched'} ${
                        state === 'CANCELLED' && 'supplierTransactionsPill--cancelled'
                    }`}
                    data-cy="transactionStatus"
                >
                    {getTransactionStateText({ state, voucherId })}
                </span>
            </td>
            <td>{formatPrice(price)}</td>
        </tr>
    )
}
